//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { IScheduledInstagramPost } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import {
  getFeedPreviewCutoffDate,
  getInstagramStandardPostDetails,
  isFailedPost,
  isInitiatedPost,
  isPostedPost,
  isReelsPost,
  isStoryPost,
} from '@instagram-account/redux/schedule/instagramScheduleUtils';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

/**
 * Determines if a scheduled post should be shown in the feed preview. We do not
 * show posts scheduled earlier than 2 weeks prior to today, story posts or posted,
 * failed, or initiated feed posts.
 */
export const shouldShowInFeedPreview = (
  post: IScheduledInstagramPost,
  tz: TimeZoneId,
) => {
  const cutoffMoment = DateString.toMoment(getFeedPreviewCutoffDate(tz), tz);
  const postDetails = getInstagramStandardPostDetails(post);
  const isPostPriorToCutoff = moment(post.scheduledTime).isBefore(cutoffMoment);

  return !(
    isPostPriorToCutoff ||
    isStoryPost(post) ||
    (isReelsPost(post) && !postDetails.shareToFeed) ||
    isPostedPost(post) ||
    isFailedPost(post) ||
    isInitiatedPost(post)
  );
};
